import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="conversation"
export default class extends Controller {
  static values = {
    url: String,
    turboFrameId: String,
  };
  connect() {
    document.getElementById(this.turboFrameIdValue).src = this.urlValue;
  }

  display(event) {
    if (event.target.id !== "show_conversation") {
      return;
    }

    let button = document.getElementById("messageToggle");

    if (button.checkVisibility()) {
      button.click();
    }
  }
}
